export class SearchBox {
  constructor(el) {
    this.el = el;
    el.addEventListener('click', e => {
      if (e.target.closest('.js-search-toggle')) this.el.classList.toggle('is-open');
    });
  }
}
